import { c as _c } from "react/compiler-runtime";
import { DropdownTableFilter } from "../../table-filter";
import { useActionsContext, useFiltersContext, usePanelContext } from "../context";
import { useDropdownFilterSetter } from "../edit-session";
import { getFilterIcon } from "../helpers";
import type { FilterTypeConfig } from "../types";
import { useMemo } from "react";
import { useProviderOptions } from "./use-provider-options";
interface FilterListItemProps {
  filterType: FilterTypeConfig;
  options: FilterTypeConfig["options"];
}
function FilterListItem(t0) {
  const $ = _c(17);
  const {
    filterType,
    options
  } = t0;
  const filterSetter = useDropdownFilterSetter(filterType);
  const {
    effectiveFilters
  } = usePanelContext();
  const {
    focusSearch
  } = useActionsContext();
  const t1 = filterType.filterKey;
  const t2 = filterType.label;
  const t3 = filterType.type;
  const t4 = effectiveFilters[filterType.filterKey];
  const t5 = filterType.className;
  const t6 = filterType.disableClear;
  const t7 = filterType.allowFutureDates;
  const t8 = filterType.direction;
  const t9 = filterType.openEnded;
  let t10;
  if ($[0] !== filterType.filterKey || $[1] !== filterType.type) {
    t10 = getFilterIcon(filterType.type, filterType.filterKey);
    $[0] = filterType.filterKey;
    $[1] = filterType.type;
    $[2] = t10;
  } else {
    t10 = $[2];
  }
  let t11;
  if ($[3] !== filterSetter || $[4] !== filterType.allowFutureDates || $[5] !== filterType.className || $[6] !== filterType.direction || $[7] !== filterType.disableClear || $[8] !== filterType.filterKey || $[9] !== filterType.label || $[10] !== filterType.openEnded || $[11] !== filterType.type || $[12] !== focusSearch || $[13] !== options || $[14] !== t10 || $[15] !== t4) {
    t11 = <DropdownTableFilter filterKey={t1} label={t2} type={t3} filterValue={t4} filterSetter={filterSetter} options={options} className={t5} disableClear={t6} allowFutureDates={t7} direction={t8} openEnded={t9} icon={t10} onBack={focusSearch} />;
    $[3] = filterSetter;
    $[4] = filterType.allowFutureDates;
    $[5] = filterType.className;
    $[6] = filterType.direction;
    $[7] = filterType.disableClear;
    $[8] = filterType.filterKey;
    $[9] = filterType.label;
    $[10] = filterType.openEnded;
    $[11] = filterType.type;
    $[12] = focusSearch;
    $[13] = options;
    $[14] = t10;
    $[15] = t4;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}
export function FilterList() {
  const $ = _c(10);
  const {
    enhancedFilterTypes
  } = useFiltersContext();
  const {
    searchQuery
  } = usePanelContext();
  const getOptionsForFilter = useProviderOptions();
  let t0;
  if ($[0] !== enhancedFilterTypes || $[1] !== searchQuery) {
    bb0: {
      const q = searchQuery.trim().toLowerCase();
      if (!q) {
        t0 = enhancedFilterTypes;
        break bb0;
      }
      const queryWords = q.split(/\s+/).filter(_temp);
      t0 = enhancedFilterTypes.filter(ft => {
        const labelLower = ft.label.toLowerCase();
        return labelLower.includes(q) || queryWords.some(word => labelLower.includes(word));
      });
    }
    $[0] = enhancedFilterTypes;
    $[1] = searchQuery;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const visibleFilterTypes = t0;
  let t1;
  if ($[3] !== getOptionsForFilter || $[4] !== visibleFilterTypes) {
    let t2;
    if ($[6] !== getOptionsForFilter) {
      t2 = filterType => <FilterListItem key={filterType.filterKey} filterType={filterType} options={getOptionsForFilter(filterType)} />;
      $[6] = getOptionsForFilter;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = visibleFilterTypes.map(t2);
    $[3] = getOptionsForFilter;
    $[4] = visibleFilterTypes;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <>{t1}</>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function _temp(w) {
  return w.length > 0;
}